const ROOT = 'DATA_UPLOADS_';

const actions = {
  LOAD_DATA_REQUEST: `${ROOT}LOAD_DATA_REQUEST`,
  LOAD_DATA_SUCCESS: `${ROOT}LOAD_DATA_SUCCESS`,
  LOAD_DATA_ERROR: `${ROOT}LOAD_DATA_ERROR`,
  LOAD_FORM_DATA_REQUEST: `${ROOT}LOAD_FORM_DATA_REQUEST`,
  LOAD_FORM_DATA_SUCCESS: `${ROOT}LOAD_FORM_DATA_SUCCESS`,
  LOAD_FORM_DATA_ERROR: `${ROOT}LOAD_FORM_DATA_ERROR`,
  UPLOAD_FILE_REQUEST: `${ROOT}UPLOAD_FILE_REQUEST`,
  UPLOAD_FILE_SUCCESS: `${ROOT}UPLOAD_FILE_SUCCESS`,
  UPLOAD_FILE_ERROR: `${ROOT}UPLOAD_FILE_ERROR`,

  SET_MODAL_VISIBLE: `${ROOT}SET_MODAL_VISIBLE`,
  SET_UPLOAD_TYPE: `${ROOT}SET_UPLOAD_TYPE`,
  SET_FILE: `${ROOT}SET_FILE`,
  DOWNLOAD_TEMPLATE_REQUEST: `${ROOT}DOWNLOAD_TEMPLATE_REQUEST`,

  CLEAR_MODAL: `${ROOT}CLEAR_MODAL`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
